import React, { useState, useEffect, useMemo } from 'react'
import { isEmpty, isEqual } from 'lodash'
import { renderField } from '../utils'
import {
  ANALYSIS_MODE,
  CHART_DEFINITION_FIELDS
} from '../../chartConfigurationsV2'


export const SingleDataStreams = ({
  streams = {},
  onChangeValue = () => null,
  onStreamsChange = () => null,
  onChange = () => { },
  selectedTableName = '',
  metricData = [],
  workspace,
  chartValues,
  maxDataStreams = null, // Restrict maximum number of datastreams
  hideAnalysisMode = false, // Hide analysis mode for raw data mode
  color = ''
}) => {
  const handleStreamChange = (updatedStream) => {
    let updatedStreams = {
      ...streams,
      ...updatedStream
    }

    onChange(updatedStreams)
  }

  return (
    <div className='chart-editor-data-streams'>
      <Stream
        key={1}
        index={0}
        chartValues={chartValues}
        streamValues={streams}
        selectedTableName={selectedTableName}
        metricData={metricData}
        onChange={(updated) => handleStreamChange(updated)}
        workspace={workspace}
        hideAnalysisMode={hideAnalysisMode}
        color={color}
      />
    </div>
  )
}

export const Stream = (props = {
  index: null,
  streamValues: null,
  selectedTableName: '',
  metricData: [],
  onChange: () => null,
  workspace,
  hideAnalysisMode: false,
  color: ''
}) => {
  const { index, streamValues, selectedTableName, metricData, onChange, workspace, hideAnalysisMode, chartValues, color } = props

  const [currentStreamValues, setCurrentStreamValues] = useState({ ...streamValues })

  useEffect(() => {
    setCurrentStreamValues({ ...streamValues })
  }, [streamValues])

  // Conditionally include analysisMode based on hideAnalysisMode prop
  const baseFields = ['breakdownType'];

  if (streamValues.breakdownType === 'compare_streams') {
    baseFields.push('dataStreams')
  }
  if (streamValues.breakdownType === 'by_category') {
    baseFields.push('metricWithGroup')
    baseFields.push('analysisMode')
  }
  const fields = [...baseFields]

  const handleFieldChange = (fieldId, value, isGrouped) => {
    const updatedStreamValues = {
      ...currentStreamValues,
      [fieldId]: value
    }

    if (fieldId === 'metricWithChild' && !isGrouped) {
      updatedStreamValues.metric = value
      updatedStreamValues.groupBy = {
        selectedTableName: '',
        metrics: [],
        metricConfig: {}
      }
    }
    if (fieldId === 'metricWithGroup' && !isGrouped) {
      updatedStreamValues.metric = value
    }

    if (fieldId === 'metricWithGroup' && isGrouped) {
      updatedStreamValues.groupBy = value;
    }

    if (fieldId === 'breakdownType') {
      updatedStreamValues.groupBy = {
        selectedTableName: '',
        metrics: [],
        metricConfig: {}
      }
      // updatedStreamValues.metric = {
      //   selectedTableName: '',
      //   metrics: [],
      //   metricConfig: {}
      // }
      // updatedStreamValues.metricWithChild = {
      //   selectedTableName: '',
      //   metrics: [],
      //   metricConfig: {}
      // }
      // updatedStreamValues.metricWithGroup = {
      //   selectedTableName: '',
      //   metrics: [],
      //   metricConfig: {}
      // }
    }

    setCurrentStreamValues(updatedStreamValues)
    onChange(updatedStreamValues)
  }


  return (
    <>
      {fields.map((fieldId, index) => {

        return renderField(fieldId, CHART_DEFINITION_FIELDS, [], currentStreamValues, {
          ...props,
          onChangeField: handleFieldChange
        })
      })}
    </>
  )
}